export const customerContractProfile = {
  title: (num) => `Kundavtal #${num}`,
  customercontract: "Avtal",
  organisations: "Organisationer",
  contactPerson: "Kontaktperson",
  priceLists: "Prislistor",
  tabInfo: "Info",
  tabDocs: "Dokument",
  snapshots: "Ramavtal",
  subVersions: "Prisavvikelse"
};
